export default function ArticleCard({
  id,
  title,
  excerpt,
  categoryName,
  tags,
  author,
  date,
  readCount,
  imageUrl,
}: {
  id: string;
  title: string;
  excerpt: string;
  categoryName: string;
  tags: string[];
  author: string;
  date: string;
  readCount: number;
  imageUrl: string;
}) {
  return (
    <article className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer">
      <a href={`/article/${id}`} className="block">
        <div className="relative h-48 overflow-hidden">
          <img
            src={imageUrl}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
          <div className="absolute top-3 left-3">
            <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs rounded-full font-medium whitespace-nowrap">
              {categoryName}
            </span>
          </div>
        </div>
        <div className="p-4 md:p-5">
          <h3 className="font-semibold text-foreground-950 text-base mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
            {title}
          </h3>
          <p className="text-sm text-foreground-600 mb-3 line-clamp-2 leading-relaxed">{excerpt}</p>
          <div className="flex items-center gap-3 text-xs text-foreground-500">
            <span>{author}</span>
            <span>·</span>
            <span>{date}</span>
            <span>·</span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line text-xs"></i>
              {readCount.toLocaleString()}
            </span>
          </div>
          <div className="flex flex-wrap gap-1.5 mt-3">
            {tags.slice(0, 3).map((tag) => (
              <span key={tag} className="px-2 py-0.5 bg-secondary-100 text-secondary-800 text-xs rounded-full">
                {tag}
              </span>
            ))}
          </div>
        </div>
      </a>
    </article>
  );
}